import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1633cabd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-organization-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View School", -1))
const _hoisted_4 = { class: "header-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "View School", -1))
const _hoisted_6 = { class: "tabs" }
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "District Name:", -1))
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name:", -1))
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Organization Type:", -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Organization Code:", -1))
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status:", -1))
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Address:", -1))
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City:", -1))
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "State:", -1))
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Zipcode:", -1))
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Phone:", -1))
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Website:", -1))
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Default School Hours:", -1))
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Early Dismissal Hours:", -1))
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Emergency Schedule Hours:", -1))
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Shortened Day Hours:", -1))
const _hoisted_38 = { class: "form-step" }
const _hoisted_39 = { class: "form-section" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Grade Levels", -1))
const _hoisted_41 = { class: "grades-container" }
const _hoisted_42 = {
  key: 0,
  class: "no-grades"
}
const _hoisted_43 = {
  key: 1,
  class: "grades-tags"
}
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Latitude:", -1))
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Longitude:", -1))
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Group Name:", -1))
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Pickup Notes:", -1))
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Drop-off Notes:", -1))
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bell Time:", -1))
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dismissal Time:", -1))
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start Date:", -1))
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End Date:", -1))
const _hoisted_62 = { class: "calendars-header" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "School Calendars", -1))
const _hoisted_64 = {
  key: 0,
  class: "loading"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading calendars...", -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = {
  key: 1,
  class: "no-data"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No calendars found for this school.", -1))
const _hoisted_69 = {
  key: 2,
  class: "calendar-list"
}
const _hoisted_70 = { class: "calendar-header" }
const _hoisted_71 = { class: "calendar-details" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Academic Year:", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Start Date:", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "End Date:", -1))
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Default Times:", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_78 = { class: "calendar-actions" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "calendar-attachments" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = {
  key: 0,
  class: "no-attachments"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No attachments", -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = {
  key: 1,
  class: "attachment-preview-list"
}
const _hoisted_88 = { class: "attachment-icon" }
const _hoisted_89 = { class: "attachment-name" }
const _hoisted_90 = {
  key: 0,
  class: "more-attachments"
}
const _hoisted_91 = ["onClick"]
const _hoisted_92 = {
  key: 0,
  class: "clone-dialog-overlay"
}
const _hoisted_93 = { class: "clone-dialog" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Clone Organization", -1))
const _hoisted_95 = { class: "dialog-actions" }
const _hoisted_96 = {
  key: 0,
  class: "error-message"
}

import { ref, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { API_URL } from "../config";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { formatTimeTo12Hour } from "../utils/timeFormat";
import axios from "axios";
import { getErrorMessage } from "../types";
import type { CalendarRecord, OrganizationRecord } from "../types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewOrganizationView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const organization = ref<OrganizationRecord>({
  id: 0,
  districtName: "",
  name: "",
  organizationType: "",
  organizationCode: "",
  address: "",
  city: "",
  state: "",
  zipcode: "",
  phone: "",
  website: "",
  defaultStartTime: "",
  defaultEndTime: "",
  earlyDismissalStartTime: "",
  earlyDismissalEndTime: "",
  emergencyStartTime: "",
  emergencyEndTime: "",
  shortenedDayStartTime: "",
  shortenedDayEndTime: "",
  isActive: false,
  prekindergarten: 0,
  kindergarten: 0,
  grade1: 0,
  grade2: 0,
  grade3: 0,
  grade4: 0,
  grade5: 0,
  grade6: 0,
  grade7: 0,
  grade8: 0,
  grade9: 0,
  grade10: 0,
  grade11: 0,
  grade12: 0,
  latitude: "0",
  longitude: "0",
  groups: [],
});

const selectedTab = ref("General Info");
const calendars = ref<CalendarRecord[]>([]);
const loadingCalendars = ref(false);

const gradesList = [
  { key: "prekindergarten", label: "Pre-K" },
  { key: "kindergarten", label: "Kindergarten" },
  { key: "grade1", label: "Grade 1" },
  { key: "grade2", label: "Grade 2" },
  { key: "grade3", label: "Grade 3" },
  { key: "grade4", label: "Grade 4" },
  { key: "grade5", label: "Grade 5" },
  { key: "grade6", label: "Grade 6" },
  { key: "grade7", label: "Grade 7" },
  { key: "grade8", label: "Grade 8" },
  { key: "grade9", label: "Grade 9" },
  { key: "grade10", label: "Grade 10" },
  { key: "grade11", label: "Grade 11" },
  { key: "grade12", label: "Grade 12" },
];

const activeGrades = computed(() => {
  return gradesList.filter((grade) => organization.value[grade.key] === 1);
});

const fetchOrganization = async (id: number) => {
  try {
    const response = await fetch(`${API_URL}/organizations/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (response.ok) {
      Object.assign(organization.value, await response.json());
    } else {
      console.error("Failed to fetch organization:", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching organization:", error);
  }
};

const fetchCalendars = async () => {
  loadingCalendars.value = true;
  try {
    const response = await axios.get(`${API_URL}/calendar`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        type: "school",
        schoolId: organization.value.id,
      },
    });

    // For each calendar, fetch its attachments
    const calendarsWithAttachments = await Promise.all(
      response.data.map(async (calendar: CalendarRecord) => {
        try {
          const attachmentsResponse = await axios.get(
            `${API_URL}/calendar/${calendar.id}/attachments`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          return { ...calendar, attachments: attachmentsResponse.data };
        } catch (error) {
          console.error(
            `Error fetching attachments for calendar ${calendar.id}:`,
            error
          );
          return { ...calendar, attachments: [] };
        }
      })
    );

    calendars.value = calendarsWithAttachments;
  } catch (error) {
    console.error("Error fetching calendars:", error);
  } finally {
    loadingCalendars.value = false;
  }
};

const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  // Adjust for timezone offset
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(date.getTime() + userTimezoneOffset);

  return adjustedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const addCalendar = () => {
  // Navigate to add calendar page with pre-filled school info
  router.push({
    name: "AddCalendar",
    query: {
      type: "school",
      schoolId: organization.value.id.toString(),
      schoolName: organization.value.name,
      returnTo: `/organizations/${organization.value.id}`,
    },
  });
};

const editCalendar = (calendarId: number) => {
  router.push({
    name: "EditCalendar",
    params: { id: calendarId },
    query: {
      returnTo: `/organizations/${organization.value.id}`,
    },
  });
};

const viewCalendar = (calendarId: number) => {
  router.push({
    name: "ViewCalendar",
    params: { id: calendarId },
    query: {
      returnTo: `/organizations/${organization.value.id}`,
    },
  });
};

const viewCalendarEvents = (calendarId: number) => {
  router.push({
    name: "CalendarEvents",
    params: { calendarId },
    query: {
      returnTo: `/organizations/${organization.value.id}`,
    },
  });
};

const viewCalendarAttachments = (calendarId: number) => {
  router.push({
    name: "ViewCalendar",
    params: { id: calendarId },
    query: {
      tab: "attachments",
      returnTo: `/organizations/${organization.value.id}`,
    },
  });
};

const showCloneDialog = ref(false);
const cloneName = ref("");
const cloneError = ref("");

const openCloneDialog = () => {
  showCloneDialog.value = true;
  cloneName.value = organization.value.name + " (Copy)";
  cloneError.value = "";
};

const submitClone = async () => {
  if (!cloneName.value.trim()) {
    cloneError.value = "Please enter a new name.";
    return;
  }
  try {
    const res = await axios.post(
      `${API_URL}/organizations/${organization.value.id}/clone`,
      {
        name: cloneName.value,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    showCloneDialog.value = false;
    // Optionally redirect to the new org details page:
    router.push(`/organizations/${res.data.id}`);
  } catch (err: unknown) {
    cloneError.value = getErrorMessage(err, "Failed to clone organization.");
  }
};

onMounted(() => {
  const id = Number(route.params.id);
  if (id) {
    fetchOrganization(id);
    // Check if the Calendars tab is selected or if there's a tab parameter in the URL
    if (selectedTab.value === "Calendars" || route.query.tab === "calendars") {
      selectedTab.value = "Calendars";
      fetchCalendars();
    }
  }
});

// Watch for tab changes to load calendars when the Calendars tab is selected
watch(selectedTab, (newTab: string) => {
  if (newTab === "Calendars" && organization.value.id) {
    fetchCalendars();
  }
});

library.add(faCopy);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _createVNode(_component_router_link, { to: "/organizations" }, {
        default: _withCtx(() => [
          _createTextVNode("Schools")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: `/organizations/${organization.value.id}/edit`,
        class: "btn-edit"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FontAwesomeIcon), { icon: "edit" }),
          _createTextVNode(" Edit School ")
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("button", {
        class: "btn-clone",
        onClick: openCloneDialog
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "copy" }),
        _createTextVNode(" Clone School ")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass({ active: selectedTab.value === 'General Info' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedTab.value = 'General Info'))
      }, " General Info ", 2),
      _createElementVNode("div", {
        class: _normalizeClass({ active: selectedTab.value === 'Grades' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedTab.value = 'Grades'))
      }, " Grades ", 2),
      _createElementVNode("div", {
        class: _normalizeClass({ active: selectedTab.value === 'Location' }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedTab.value = 'Location'))
      }, " Location ", 2),
      _createElementVNode("div", {
        class: _normalizeClass({ active: selectedTab.value === 'Groups' }),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedTab.value = 'Groups'))
      }, " Groups ", 2),
      _createElementVNode("div", {
        class: _normalizeClass({ active: selectedTab.value === 'Calendars' }),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (selectedTab.value = 'Calendars'))
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "calendar" }),
        _createTextVNode(" Calendars ")
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("p", null, _toDisplayString(organization.value.districtName), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("p", null, _toDisplayString(organization.value.name), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("p", null, _toDisplayString(organization.value.organizationType), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("p", null, _toDisplayString(organization.value.organizationCode), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("p", null, [
            _createElementVNode("span", {
              class: _normalizeClass([
                'status-badge',
                organization.value.isActive ? 'active' : 'inactive',
              ])
            }, _toDisplayString(organization.value.isActive ? "Active" : "Inactive"), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("p", null, _toDisplayString(organization.value.address), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("p", null, _toDisplayString(organization.value.city), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("p", null, _toDisplayString(organization.value.state), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("p", null, _toDisplayString(organization.value.zipcode), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("p", null, _toDisplayString(organization.value.phone), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("p", null, _toDisplayString(organization.value.website), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("p", null, _toDisplayString(_unref(formatTimeTo12Hour)(organization.value.defaultStartTime)) + " - " + _toDisplayString(_unref(formatTimeTo12Hour)(organization.value.defaultEndTime)), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("p", null, _toDisplayString(_unref(formatTimeTo12Hour)(organization.value.earlyDismissalStartTime)) + " - " + _toDisplayString(_unref(formatTimeTo12Hour)(organization.value.earlyDismissalEndTime)), 1)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("p", null, _toDisplayString(_unref(formatTimeTo12Hour)(organization.value.emergencyStartTime)) + " - " + _toDisplayString(_unref(formatTimeTo12Hour)(organization.value.emergencyEndTime)), 1)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("p", null, _toDisplayString(_unref(formatTimeTo12Hour)(organization.value.shortenedDayStartTime)) + " - " + _toDisplayString(_unref(formatTimeTo12Hour)(organization.value.shortenedDayEndTime)), 1)
        ])
      ], 512), [
        [_vShow, selectedTab.value === 'General Info']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            (activeGrades.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, " No grade levels configured "))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeGrades.value, (grade) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: grade.key,
                      class: "grade-tag"
                    }, _toDisplayString(grade.label), 1))
                  }), 128))
                ]))
          ])
        ])
      ], 512), [
        [_vShow, selectedTab.value === 'Grades']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("p", null, _toDisplayString(organization.value.latitude), 1)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("p", null, _toDisplayString(organization.value.longitude), 1)
        ])
      ], 512), [
        [_vShow, selectedTab.value === 'Location']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organization.value.groups, (group, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "group-container"
          }, [
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("p", null, _toDisplayString(group.name), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("p", null, _toDisplayString(group.pickupNotes), 1)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("p", null, _toDisplayString(group.dropOffNotes), 1)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("p", null, _toDisplayString(group.bellTime), 1)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("p", null, _toDisplayString(group.dismissalTime), 1)
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("p", null, _toDisplayString(group.startDate), 1)
            ]),
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("p", null, _toDisplayString(group.endDate), 1)
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, selectedTab.value === 'Groups']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("button", {
            class: "btn-add",
            onClick: addCalendar
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: "plus" }),
            _createTextVNode(" Add Calendar ")
          ])
        ]),
        (loadingCalendars.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, _hoisted_66))
          : (calendars.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("button", {
                  class: "btn-add-calendar",
                  onClick: addCalendar
                }, [
                  _createVNode(_unref(FontAwesomeIcon), { icon: "plus" }),
                  _createTextVNode(" Create First Calendar ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendars.value, (calendar) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: calendar.id,
                    class: "calendar-card"
                  }, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("h3", null, _toDisplayString(calendar.name), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["calendar-type", calendar.type])
                      }, _toDisplayString(calendar.type), 3)
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("p", null, [
                        _hoisted_72,
                        _createTextVNode(" " + _toDisplayString(calendar.academicYear || "N/A"), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_73,
                        _createTextVNode(" " + _toDisplayString(formatDate(calendar.startDate)), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_74,
                        _createTextVNode(" " + _toDisplayString(formatDate(calendar.endDate)), 1)
                      ]),
                      (calendar.defaultStartTime || calendar.defaultEndTime)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_75, [
                            _hoisted_76,
                            _createTextVNode(" " + _toDisplayString(calendar.defaultStartTime || "N/A") + " - " + _toDisplayString(calendar.defaultEndTime || "N/A"), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, [
                        _hoisted_77,
                        _createElementVNode("span", {
                          class: _normalizeClass('status-' + calendar.status)
                        }, _toDisplayString(calendar.status), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("button", {
                        class: "btn-view",
                        onClick: ($event: any) => (viewCalendar(calendar.id))
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "eye" }),
                        _createTextVNode(" View Details ")
                      ], 8, _hoisted_79),
                      _createElementVNode("button", {
                        class: "btn-edit",
                        onClick: ($event: any) => (editCalendar(calendar.id))
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "edit" }),
                        _createTextVNode(" Edit ")
                      ], 8, _hoisted_80),
                      _createElementVNode("button", {
                        class: "btn-events",
                        onClick: ($event: any) => (viewCalendarEvents(calendar.id))
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "calendar-day" }),
                        _createTextVNode(" Events ")
                      ], 8, _hoisted_81)
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("h4", null, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "paperclip" }),
                        _createTextVNode(" Attachments "),
                        (calendar.attachments && calendar.attachments.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_83, "(" + _toDisplayString(calendar.attachments.length) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (
                  !calendar.attachments || calendar.attachments.length === 0
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, _hoisted_86))
                        : (_openBlock(), _createElementBlock("div", _hoisted_87, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendar.attachments.slice(0, 3), (attachment) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: attachment.id,
                                class: "attachment-preview-item"
                              }, [
                                _createElementVNode("div", _hoisted_88, [
                                  (attachment.type === 'pdf')
                                    ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                                        key: 0,
                                        icon: "file-pdf"
                                      }))
                                    : (attachment.type === 'document')
                                      ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                                          key: 1,
                                          icon: "file-word"
                                        }))
                                      : (attachment.type === 'image')
                                        ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                                            key: 2,
                                            icon: "image"
                                          }))
                                        : (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                                            key: 3,
                                            icon: "file"
                                          }))
                                ]),
                                _createElementVNode("span", _hoisted_89, _toDisplayString(attachment.originalFilename), 1)
                              ]))
                            }), 128)),
                            (calendar.attachments.length > 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                  _createElementVNode("span", null, "+" + _toDisplayString(calendar.attachments.length - 3) + " more", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])),
                      _createElementVNode("button", {
                        class: "btn-view-all",
                        onClick: ($event: any) => (viewCalendarAttachments(calendar.id))
                      }, " View All Attachments ", 8, _hoisted_91)
                    ])
                  ]))
                }), 128))
              ]))
      ], 512), [
        [_vShow, selectedTab.value === 'Calendars']
      ])
    ]),
    (showCloneDialog.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _hoisted_94,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cloneName).value = $event)),
              placeholder: "New Organization Name",
              required: ""
            }, null, 512), [
              [_vModelText, cloneName.value]
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("button", { onClick: submitClone }, "Clone"),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showCloneDialog.value = false))
              }, "Cancel")
            ]),
            (cloneError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(cloneError.value), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})